import * as React from 'react';
import { calls } from './reducers/calls';
import { translations, setTranslations } from './reducers/translations';
import { chats, selectChatId, selectLabels } from './reducers/chats';
import { ColorSchema, Endpoints, FormTypes } from './models/types';
import Communications from './components/Communications';
import { selectShowActionsPanel } from './reducers/chats';
import './styles/Main.scss';

interface CommunicationsModuleProps {
  instance: any;
  endpoints: Endpoints;
  baseURL: string;
  signalRBaseURL: string;
  pagePath?: string;
  accessToken: string | null;
  callSignalRConnection?: any;
  sendMessageFormType: FormTypes;
  sendMessageAdditionalParams: any;
  colorSchema: ColorSchema;
  videoCall: boolean;
  phoneCall: boolean;
  allowAttachments: boolean;
  attachmentMaxSizeInMB?: number;
  attachmentTypesAllowed?: string[];
  hasContactList: boolean;
  urlChatId: number | null;
  useDispatch: any;
  useSelector: any;
  chatHeaderButtonHandler?: any;
  chatHeaderToggleHandler?: any;
}

export { calls };
export { chats };
export { translations };
export { setTranslations };
export { selectShowActionsPanel };
export { selectChatId };
export { selectLabels };

export const CommunicationsModule: React.FC<CommunicationsModuleProps> = props => {
  return <Communications {...props} />;
};
